import { render, staticRenderFns } from "./loanInfo.vue?vue&type=template&id=45114983&scoped=true&"
import script from "./loanInfo.vue?vue&type=script&lang=ts&"
export * from "./loanInfo.vue?vue&type=script&lang=ts&"
import style0 from "./loanInfo.vue?vue&type=style&index=0&id=45114983&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45114983",
  null
  
)

export default component.exports